import React, { useState, useEffect } from 'react';
import { X, Save, X as XIcon } from 'lucide-react';
import { ColorPicker } from 'antd';

const CourseDetailsModal = ({
  isOpen,
  onClose,
  courses,
  editingCourse,
  onUpdateCourse
}) => {
  const [editingCourses, setEditingCourses] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setEditingCourses([...courses]);
    }
  }, [isOpen, courses]);

  if (!isOpen) return null;

  const handleCourseChange = (index, field, value) => {
    const newCourses = [...editingCourses];
    newCourses[index] = { ...newCourses[index], [field]: value };
    setEditingCourses(newCourses);
  };

  const handleSave = () => {
    // 收集所有需要更新的课程
    const updates = [];
    
    editingCourses.forEach((course, index) => {
      const originalCourse = courses[index];
      if (originalCourse) {
        // 检查是否有任何字段发生变化
        const hasChanges = course.name !== originalCourse.name ||
                          course.color !== originalCourse.color ||
                          course.teacher !== originalCourse.teacher ||
                          course.location !== originalCourse.location;
        
        if (hasChanges) {
          updates.push({ oldName: originalCourse.name, newCourse: course });
        }
      }
    });
    
    // 批量更新所有课程
    if (updates.length > 0) {
      onUpdateCourse(updates);
    }
    
    onClose();
  };

  const handleCancel = () => {
    setEditingCourses([...courses]);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content max-w-4xl relative" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 - 右上角 */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-100 z-10 flex items-center justify-center"
        >
          <X size={18} />
        </button>

        <div className="modal-header">
          <h2 className="modal-title">课程详情设置</h2>
        </div>
        
        <div className="modal-body">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {editingCourses.map((course, index) => (
              <div key={index} className="course-detail-item bg-gray-50 rounded-lg p-6 border border-gray-200">
                <h4 className="text-primary-600 mb-6 text-lg font-semibold flex items-center gap-3">
                  <div 
                    className="w-4 h-4 rounded-full border border-gray-300"
                    style={{ backgroundColor: course.color }}
                  />
                  {course.name || `课程 ${index + 1}`}
                </h4>
                
                <div className="space-y-4">
                  <div className="course-detail-group">
                    <label className="course-detail-label">课程名称</label>
                    <input
                      type="text"
                      value={course.name}
                      onChange={(e) => handleCourseChange(index, 'name', e.target.value)}
                      className="course-detail-input"
                    />
                  </div>
                  
                  <div className="course-detail-group">
                    <label className="course-detail-label">课程颜色</label>
                    <div className="flex items-center gap-3">
                      <ColorPicker
                        value={course.color}
                        onChange={(color) => handleCourseChange(index, 'color', color.toHexString())}
                        showText
                        size="large"
                        style={{ width: '120px' }}
                      />
                    </div>
                  </div>
                  
                  <div className="course-detail-group">
                    <label className="course-detail-label">任课教师</label>
                    <input
                      type="text"
                      value={course.teacher}
                      onChange={(e) => handleCourseChange(index, 'teacher', e.target.value)}
                      className="course-detail-input"
                      placeholder="请输入教师姓名"
                    />
                  </div>
                  
                  <div className="course-detail-group">
                    <label className="course-detail-label">上课地点</label>
                    <input
                      type="text"
                      value={course.location}
                      onChange={(e) => handleCourseChange(index, 'location', e.target.value)}
                      className="course-detail-input"
                      placeholder="请输入教室或地点"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={handleSave}>
            <Save size={16} className="mr-2" />
            保存
          </button>
          <button className="btn btn-danger" onClick={handleCancel}>
            <XIcon size={16} className="mr-2" />
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseDetailsModal;
